export default class UnitCountCalculationError extends Error {
    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, UnitCountCalculationError.prototype);
    }
}
